export const createLifecycleOperationUuid = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();

  const hex = length =>
    Array.from({ length }, () =>
      Math.floor(Math.random() * 16).toString(16)
    ).join('');
  const variant = ['8', '9', 'a', 'b'][Math.floor(Math.random() * 4)];
  return `${hex(8)}-${hex(4)}-4${hex(3)}-${variant}${hex(3)}-${hex(12)}`;
};
